import { Seo } from "@/components/Seo";
import { WinnersWall } from "@/components/sotm/WinnersWall";
import { breadcrumb } from "@/lib/site";

export default function SotmWall() {
  return (
    <div className="mx-auto max-w-[1440px] px-5 pb-28 pt-16 sm:px-10 lg:pt-24" data-testid="sotm-wall-page">
      <Seo title="Wall of Sus: every Sus of the Month winner" description="Every teen designer who won Sus of the Month at the suspects, with their story and their tee." path="/sus-of-the-month/wall"
        jsonLd={[breadcrumb([{ name: "Home", path: "/" }, { name: "Sus of the Month", path: "/sus-of-the-month" }, { name: "Wall of Sus", path: "/sus-of-the-month/wall" }])]} />
      <WinnersWall testid="wall-page" />
    </div>
  );
}
